<template>
  <div class="research-tooltip">
    <h4 class="research-tooltip__title">{{ title }}</h4>
    <p class="research-tooltip__description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.research-tooltip {
  background-color: rgba(50, 50, 52, 0.95);
  min-width: 320px;
  border: 1px solid #ddd;
  border-radius: $bb-spacing-2;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  padding: $bb-spacing-3;
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-2;
  z-index: 1000;
  position: absolute;
  right: 40px;
  top: 0;

  &__title {
    @include bb-regular-text-styles('sm');
    font-weight: 600;
    color: $bb-neutral-0;
    margin: 0;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  &__description {
    @include bb-regular-text-styles('xs');
    color: $bb-neutral-0;
    margin: 0;
    white-space: pre-line;
    overflow: visible;
    text-overflow: unset;
  }
}
</style>
